module.exports = __webpack_public_path__ + "img/logo-unud.60c96a8f.png";